<div class="panel_wrapper">
  <p-progressSpinner class="w-100 text-center " *ngIf="spinner"></p-progressSpinner>
  <div class="pb-4 text-center delete_message">
      <h4>{{'SUBCATEGORY.CONFIRM_DELETE_MESSAGE' | translate}}</h4>
    </div>
    <div class="d-flex flex-row justify-content-between pb-4">
      <button class="btn_delete w_45 mt-0" (click)="deleteSubcategory(subcategoryId)">{{ 'DELETE' |
        translate}}</button>
      <button class="btn_cancel w_45" (click)="cancel()">{{ 'CANCEL' | translate }}</button>
    </div>
  </div>
